import { EditOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import { useState } from 'react';

import type { DocumentType } from '@/gql';

import type {
  FILE_URL_DIALOG_FILES_FOR_OWNER_FRAGMENT,
  FILE_URL_DIALOG_FILE_FRAGMENT,
} from '../../../../dialogs/UpdateFileUrlDialog';
import { UpdateFileUrlDialog } from '../../../../dialogs/UpdateFileUrlDialog';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

interface Props {
  file: DocumentType<typeof FILE_URL_DIALOG_FILE_FRAGMENT>;
  filesForOwner: DocumentType<typeof FILE_URL_DIALOG_FILES_FOR_OWNER_FRAGMENT>;
  canEdit: boolean;
  canLockRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const EditLinkOrNameMenuItem = ({
  file,
  filesForOwner,
  canEdit,
  canLockRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <MaybeUsableMenuItem
        isUsable={canEdit}
        isExpectedUsable={canLockRoot}
        unusableExplanation={unusableExplanation}
        onClick={() => {
          setDialogOpen(true);
          onClose();
        }}
      >
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary="Edit link or name" />
      </MaybeUsableMenuItem>
      <UpdateFileUrlDialog
        file={file}
        filesForOwner={filesForOwner}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
